var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7ED957;stroke:#7ED957;stroke-width:0.925;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,31.5c-1.1-1.1-2.8-1.1-3.9,0L38,43.4l-5-5c-1.1-1.1-2.8-1.1-3.9,0s-1.1,2.8,0,3.9l6.9,6.9 c0.5,0.5,1.3,0.8,2,0.8s1.4-0.3,2-0.8l13.9-13.8C54.9,34.3,54.9,32.6,53.9,31.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70,37.6c-1.5,0-2.8,1.2-2.8,2.8c0,15.3-12.5,27.8-27.8,27.8S11.6,55.7,11.6,40.4s12.5-27.8,27.8-27.8 c7.5,0,14.5,2.9,19.7,8.2c1.1,1.1,2.8,1.1,3.9,0s1.1-2.8,0-3.9c-6.3-6.3-14.7-9.8-23.6-9.8C21,7.1,6.1,22,6.1,40.4 s15,33.3,33.3,33.3c18.4,0,33.3-15,33.3-33.3C72.7,38.9,71.5,37.6,70,37.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCircle);
export default __webpack_public_path__ + "static/media/confirm-circle.2898a441304498611671033debf6d3fb.svg";
export { ForwardRef as ReactComponent };